import { createStore } from 'vuex';
import createPersistedstate from 'vuex-persistedstate';
import area from './module/area';
import user from './module/user';
import filter from './module/filter';
import learning from './module/learning';
import exam from "./module/exam";

// import * as Api from '@/api/api'
// import * as Tools from '@/assets/utils/tools'
import * as Cache from '@/assets/utils/cache'

export default createStore({
  plugins: [
    createPersistedstate({
      key: 'gjkcVuex'
    })
  ],
  state: {
    /** token */
    token:'',
    /** 信息用户 */
    userInfo: {},
    /** 展示登录弹框 */
    showLogin:false,
  },
  mutations: {
    /** token */
    setToken(state, value){
      state.token = value;
      Cache.set('token', value);
			localStorage.setItem("token", value);
    },

    /** 信息用户 */
    setUserInfo(state, value){
      state.userInfo = value;
      Cache.set('userInfo', value);

			// 登录后设置goEasy用户信息
			const { buyerUserId, headImage, name } = value;
			state.goUserInfo = {
        id: buyerUserId,
				userId: `XS_${buyerUserId}`,
				avatar: headImage,
				username: name,
				type: "XS",
			};
			localStorage.setItem("goUserInfo", JSON.stringify(state.goUserInfo));
			Cache.set('goUserInfo', value);
    },

    /**
     * 登录弹框展示
     */
    setShowLogin(state,value){
      state.showLogin = value;
    }
  },
  actions: {
  },
  modules: {
    area,user,filter,learning,exam
  }
})
